<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="cancel()" />
</div>
<ion-content [fullscreen]="true">
  <ion-title class="smaller">
    <h1>
      Problemer for {{ vehicle.vendor }} {{ vehicle.information.model }}
      {{ vehicle.information.year }}
    </h1>
  </ion-title>

  <p>Handlinger som kreves</p>
  <div>
    <ul class="intervention-list">
      <li *ngFor="let intervention of interventions">
        <p class="heading-3 intervention-title">
          {{ intervention.resolution.title }}
        </p>
        <p [innerHTML]="parseIntervention(intervention)" class="intervention-item"></p>
      </li>
    </ul>
  </div>


  <!-- <p>
    ChargeState:
    {{ vehicle.capabilities.chargeState.interventionIds.join(', ') }}
  </p>
  <p>
    Information:
    {{ vehicle.capabilities.information.interventionIds.join(', ') }}
  </p>
  <p>
    Location:
    {{ vehicle.capabilities.location.interventionIds.join(', ') }}
  </p>
  <p>
    Odometer:
    {{ vehicle.capabilities.odometer.interventionIds.join(', ') }}
  </p>
  <p>
    SmartCharging:
    {{ vehicle.capabilities.smartCharging.interventionIds.join(', ') }}
  </p>
  <p>
    StartCharging:
    {{ vehicle.capabilities.startCharging.interventionIds.join(', ') }}
  </p>
  <p>
    StopCharging:
    {{ vehicle.capabilities.stopCharging.interventionIds.join(', ') }}
  </p> -->
</ion-content>